<template>
  <div class="baoxiu_list">
    <section>
      <li class="baoxiu_item" v-for="(item, ind) in list" :key="ind" >
        <p class="baoxiu_flex">
                <span>
                    采暖期: {{item.cnq}}
                </span>
         <span :class="getColor(item.shzt)">
              {{item.shzt}}
          </span>
        </p>
        <p class="baoxiu_flex">
            <span>
                复供面积：{{-item.tgmj}} m²
            </span>
        </p>
        <p class="baoxiu_flex">
                <span>
                    停供类型：{{item.tglx}}
                </span>

        </p>
        <p class="baoxiu_flex">
                <span>
                    停供原因：{{item.tgyy}}
                </span>
        </p>
        <p class="baoxiu_flex">
            <span>
                申请日期：{{item.sqrq}}
            </span>
        </p>
      </li>
      <p class="no_data" v-if="!list.length">
        暂无业务记录
      </p>
    </section>
    <footer>
      <button class="btn_bx" @click="goPage" type="primary">申 请 复 供</button>
    </footer>

  </div>
</template>

<script>
  import { getYwjl } from '@/api'
  import {validSlsx} from "@/utils";
  export default {
    data() {
      return {
        list: [],
      }
    },
    mounted() {
      this.getList()
    },
    methods: {
      getList(){
        let params = {
          customerId: this.$route.query.userId,
          type: 'fg'
        }
        getYwjl(params).then(res=> {
          this.list = res.data.fgList
        })
      },
      jjyy(item) {
        if(item.shzt=='未通过') {
          this.$router.push({
            path: '/jjyy',
            query: {
              id: item.id
            }
          })
        }
      },
      getValue(status) {
        let arr = ['待处理', '处理中', '待评价','', '已完成']
        return arr[status]
      },
      getColor(type) {
        let className = 'text_green'
        if(type=='审核中') {
          className = 'text_orange'
        } else if(type=='未通过') {
          className = 'text_red'
        }

        return className
      },
      goPage() {
        if(validSlsx('复供')){
          this.$router.push({
            path: '/fgChange',
            query: this.$route.query
          })
        }
      }
    }
  }
</script>

<style scoped>

  .baoxiu_list{
    display:-webkit-box;
    display:-webkit-flex;
    display:-ms-flexbox;
    display:flex;
    -webkit-box-orient:vertical;
    -webkit-flex-direction:column;
    -ms-flex-direction:column;
    flex-direction:column;
    width:100%;
    height:90%;
  }
  .demo-ruleForm{
    margin-top: 5px;
    margin-left: 10px;
  }
  .btn_bx{
    width: 94%;
    margin-left: 3%;
    /*margin-top: 3rem;*/
    font-size: 1rem;
    height: 2.5rem;
    background: #47c34d;
    border-radius: 3px;
  }
  .text_green{
    color: #47c34d;
  }
  .text_red{
    color: red;
  }
  .text_orange{
    color:orange;
  }
  header,footer{
    height:40px;
    line-height: 40px;

    /*text-align:center;*/
  }
  header{
    margin-bottom: 5px;
    background-color:#fff;

  }
  section{
    -webkit-box-flex:1;
    -webkit-flex:1;
    -ms-flex:1;
    flex:1;
    width:100%;
    overflow:auto;/* winphone8和android4+ */
    -webkit-overflow-scrolling: touch; /* ios5+ */
  }

  .baoxiu_item{
    border-bottom: 5px solid #f1f1f1;
    padding: 3%;
    line-height: 25px;
    background: #fff;
  }
  .baoxiu_flex{
    display: flex;
    justify-content: space-between;
  }
  .goPj{
    color: #1890ff;
  }

</style>



// WEBPACK FOOTER //
// src/view/ywbl/fg/fgList.vue